var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import cx from "clsx";
import { Category } from "../Category";
export var Nav = function (_a) {
    var children = _a.children, categories = _a.categories, className = _a.className, setHasCategoryOpen = _a.setHasCategoryOpen;
    var _b = useState(null), currentCategory = _b[0], setCurrentCategory = _b[1];
    var baseClass = "nav absolute md:static top-16 md:top-auto order-last md:order-none md:h-auto md:max-h-initial w-full md:w-auto bg-white";
    var layoutClass = "block md:max-h-initial overflow-hidden md:overflow-auto";
    var transitionClass = "transition-max-h duration-300 ease-linear";
    return (React.createElement("nav", { className: cx(baseClass, layoutClass, transitionClass, className) },
        categories.map(function (cat, index) { return (React.createElement(Category, __assign({}, cat, { key: index, categoryIndex: index, currentCategory: currentCategory, setCurrentCategory: setCurrentCategory, setHasCategoryOpen: setHasCategoryOpen }))); }),
        children));
};
//# sourceMappingURL=Nav.js.map